import React from 'react'

import { FormattedMessage } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'

import BrandFansGroupRowTrackedRoute from '@components/BrandFans/Group/Row/TrackedRoute'
import SortMenu from '@components/UI/SortMenu'
import { EventTrackingNames } from '@enums'
import { IApplicationState } from '@store'
import { fetchBrandFanGroupMembers, selectBrandFanGroupMembersSortOptions } from '@store/brandFans'
import { Container } from '@tribegroup'

interface IProps {
  groupId: number
}

const BrandFansGroupDetailsSort: React.FC<IProps> = ({ groupId }) => {
  const dispatch = useDispatch()
  const sortOptions = useSelector((state: IApplicationState) =>
    selectBrandFanGroupMembersSortOptions(state, groupId),
  )

  const onSortByChange = (sortBy?: string) => {
    // Only trigger the fetch if we have a valid sort value
    if (sortBy) {
      const resetList = true
      dispatch(fetchBrandFanGroupMembers(groupId, false, resetList, sortBy))
    }
  }

  return (
    <Container data-testid="brand-fans-group-details-sort">
      <SortMenu
        anchor={'right'}
        trackingWrapper={{
          component: BrandFansGroupRowTrackedRoute,
          createProps: (value: string) => ({
            eventName: EventTrackingNames.BrandFansGroupDetailView,
            groupId,
            sortBy: value,
            additionalProperties: {
              source: 'sort_filter',
            },
          }),
        }}
        options={sortOptions.map((option) => ({
          value: option,
          display: <FormattedMessage id={`brandFans.list.sort.option.${option}`} />,
        }))}
        onSortByChange={onSortByChange}
      />
    </Container>
  )
}

export { BrandFansGroupDetailsSort }
export default BrandFansGroupDetailsSort
